/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisualizzazioneTipoPratica } from './visualizzazione-tipo-pratica';
import { TipoPraticaStato } from './tipo-pratica-stato';
import { TipologiaPratica } from './tipologia-pratica';


export interface TipoPraticaListFilter { 
    comune_id?: string;
    codice?: string;
    tipologia?: TipologiaPratica;
    stato?: TipoPraticaStato;
    visualizzazione?: VisualizzazioneTipoPratica;
    q?: string;
    fase?: TipoPraticaListFilterFaseEnum;
    solo_submit_per_cittadino?: boolean;
}
export enum TipoPraticaListFilterFaseEnum {
    TUTTI = 'TUTTI',
    APERTI = 'APERTI',
    CHIUSI = 'CHIUSI',
    FUTURI = 'FUTURI',
    SENZA_DATE = 'SENZA_DATE'
};



